export class ModelPaperReqModal{
    instructions: string;
    noOfSections: number;
    marks: number;
    noOfQuestions: number;
    totalTime: number;
    tagline: string;
    partName: string;
}